// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1clDB","name":"ConsentHeader_name__2jTF6","birthday":"ConsentHeader_birthday__2wvpc","skeleton":"ConsentHeader_skeleton__3Fzub"};